import vendor from "fragments/vendors/vendor"
import { gql } from "graphql-tag"

const ADD_VENDOR = gql`
  ${vendor}

  mutation addVendor(
    $vendorAddInput: VendorAddInput!
    $socialLinksAddInput: SocialLinksAddInput
  ) {
    addVendor(
      vendorAddInput: $vendorAddInput
      socialLinksAddInput: $socialLinksAddInput
    ) {
      ...Vendor
    }
  }
`

export default ADD_VENDOR
